/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design System — LogicalOperatorToggle (AND/OR) sub-primitive
 */
import cx from 'classnames';
import React from 'react';

import Button from '../../components/Button/Button';
import type { ValidationLogicalOperator } from '../../types';

import './LogicalOperatorToggle.less';

export interface LogicalOperatorToggleProps {
  /** Controlled value — `'AND'` or `'OR'` */
  value: ValidationLogicalOperator;
  /** Fires with the toggled operator when the user clicks */
  onChange: (next: ValidationLogicalOperator) => void;
  /** Disables the button */
  disabled?: boolean;
  /** Extra class merged onto the outer wrapper */
  className?: string;
}

const LogicalOperatorToggle: React.FC<LogicalOperatorToggleProps> = ({ value, onChange, disabled, className }) => {
  const handleClick = React.useCallback(() => {
    onChange(value === 'AND' ? 'OR' : 'AND');
  }, [value, onChange]);

  return (
    <div className={cx('ds-logical-operator-toggle', className)}>
      <Button variant="secondary" size="medium" disabled={disabled} onClick={handleClick}>
        {value}
      </Button>
    </div>
  );
};

LogicalOperatorToggle.displayName = 'LogicalOperatorToggle';

export { LogicalOperatorToggle };
export default LogicalOperatorToggle;
